import { create } from "zustand";

const useRawValuesStore = create<{
  showRawValues: boolean;
  setShowRawValues: (showRawValues: boolean) => void;
}>(set => ({
  showRawValues: false,
  setShowRawValues: showRawValues => set({ showRawValues }),
}));

export default useRawValuesStore;
